module.exports = __webpack_public_path__ + "static/img/Banner 3.2882084d.jpg";